// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__c2lUy","open":"Accordion_open__gEvoN"};